module.exports = __webpack_public_path__ + "static/media/Joe_Passafiume_Resume.0c37b16b.jpg";